// React Component
import React from 'react'

// App Component
import { AppLayout, HeaderLayout } from '../../layouts'
import { useHeaderLayoutCompanyData } from '../../hooks/useHeaderLayoutCompanyData'

// Features
import { GroupOfProcessCreate } from '../../features/process/process'

const NewGroupOfProcessView = () => {
    const headerProps = useHeaderLayoutCompanyData()

    return (
        <AppLayout>
            <>
                <HeaderLayout {...headerProps} />
                <div className="px-3 mt-2 h-100 ">
                    <div className='container mt-5' >
                        <GroupOfProcessCreate />
                    </div>

                </div>
            </>
        </AppLayout>
    )
}

export default NewGroupOfProcessView
